export default {
  kbSearchListEmptyState: '0 articles found',
  articlesEmptyAltText: 'Articles empty',
};
